import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tos/page.tsx");
